import { api } from "./axiosInstance";

export type RelationshipLevelRes = {
  level: number;
  title: string;
  description: string;
};

export const apiGetRelationshipLevels = async (): Promise<
  RelationshipLevelRes[]
> => {
  const response = await api.get("/api/relationship-level");
  return response.data;
};

export const apiUpdateRelationshipLevel = async (
  profileId: string,
  level: number | null
): Promise<void> => {
  await api.patch(`/api/page/profile/${profileId}/relationship-level`, {
    level,
  });
};
